import "./achievements.css";

import React from 'react';

function Achievements() {
  return (
    <section className="achievements">
      <h2>Achievements and Certifications</h2>
      <p>I'm a full-stack developer skilled in AI, cybersecurity, and scalable software systems.</p>
      <ul>
        <li>
          <strong>Certificate of Publication</strong> - Project Publication (May 2025)
          <br />
          <a href="/documents/publication.png" download="Urban ZoomIN Publication Certificate"  target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Cyber Security Fundamentals</strong> - IBM (Feb 2025)
          <br />
          <a href="https://www.linkedin.com/in/srinadh-chintakindi-887550232/details/certifications/1175206625/multiple-media-viewer/?profileId=ACoAADoZ9ecBJPE_iSkz2OdIVCEWEfkG4mNXEk4&treasuryMediaId=1740637577553" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Selected for National Startups</strong> - Ministry of Education, AICTE (Jan 2025)
          <br />
          <a href="https://www.linkedin.com/feed/update/urn:li:activity:7287817156707131392/" target="_blank" rel="noopener noreferrer">View Details</a>
        </li>
        <li>
          <strong>Database for Developers</strong> - Oracle Corporation (Jan 2025)
          <br />
          <a href="https://www.linkedin.com/in/srinadh-chintakindi-887550232/details/certifications/1737983809023/single-media-viewer/?profileId=ACoAADoZ9ecBJPE_iSkz2OdIVCEWEfkG4mNXEk4" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Project Management with JIRA</strong> - Reliance Foundation (Dec 2024)
          <br />
          <a href="https://www.linkedin.com/in/srinadh-chintakindi-887550232/details/certifications/1733571671115/single-media-viewer/?profileId=ACoAADoZ9ecBJPE_iSkz2OdIVCEWEfkG4mNXEk4" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Introduction to Gen AI</strong> - Google Cloud Skills (Sep 2024)
          <br />
          <a href="https://www.cloudskillsboost.google/public_profiles/0813eec8-95a4-422d-842c-1b52db78db42/badges/11399504?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share" target="_blank" rel="noopener noreferrer">View Badge</a>
        </li>
        <li>
          <strong>Introduction to LLMs</strong> - Google Cloud Skills (Sep 2024)
          <br />
          <a href="https://www.cloudskillsboost.google/public_profiles/0813eec8-95a4-422d-842c-1b52db78db42/badges/11400774?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share" target="_blank" rel="noopener noreferrer">View Badge</a>
        </li>
        <li>
          <strong>Software Engineer Intern</strong> - HackerRank (Sep 2024)
          <br />
          <a href="https://www.hackerrank.com/certificates/iframe/91bf24c77ae2" target="_blank" rel="noopener noreferrer">View Certificate</a>
        </li>
        <li>
          <strong>Machine Learning Certification</strong> - Kaggle (Sep 2024)
          <br />
          <a href="https://www.kaggle.com/learn/certification/srinadhch07/machine-learning-explainability" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Certified Django Practitioner</strong> - Microsoft (Sep 2024)

          <a href="https://learn.microsoft.com/en-in/users/srinadhch07-8105/achievements/dc5az4sj?ref=https%3A%2F%2Fwww.linkedin.com%2F" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>Certified Pandas Practitioner</strong> - Kaggle (Apr 2024)
          <br />
          <a href="https://www.kaggle.com/learn/certification/srinadhch07/pandas" target="_blank" rel="noopener noreferrer">View Certification</a>
        </li>
        <li>
          <strong>5-Star in Python Programming</strong> - HackerRank
          <br />
          <a href="https://www.hackerrank.com/profile/srinadhc07" target="_blank" rel="noopener noreferrer">View Profile</a>
        </li>
        <li>
          <strong>Contributed to Python Developer Community - pyarcS Python package</strong> (Apr 2024)
          <br />
          <a href="https://pypi.org/project/pyarcS/" target="_blank" rel="noopener noreferrer">View on PyPI</a>
        </li>
      </ul>
    </section>
  );
}

export default Achievements;
